import { create } from 'zustand';
import { AuthResponse, UserRole } from '../types';
import { authService } from '../services/auth.service';

interface AuthState {
  user: AuthResponse | null;
  isAuthenticated: boolean;
  setUser: (user: AuthResponse | null) => void;
  logout: () => void;
  hasRole: (role: UserRole) => boolean;
  hasAnyRole: (roles: UserRole[]) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: authService.getCurrentUser(),
  isAuthenticated: authService.isAuthenticated(),
  
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  
  logout: () => {
    authService.logout();
    set({ user: null, isAuthenticated: false });
  },
  
  hasRole: (role) => {
    const { user } = get();
    return user?.roles.includes(role) || false;
  },
  
  hasAnyRole: (roles) => {
    const { user } = get();
    if (!user) return false;
    return roles.some(role => user.roles.includes(role));
  },
}));
